import React from "react";
import ReactDOM from "react-dom";
import {get} from './components/Storage';
// Init Configuration
import './components/Init';
import App from './components/App';

var AppSettings = get();

ReactDOM.render(<App />, document.getElementById(AppSettings.topnews));